import React from 'react';
import { useTranslation } from '../lib/i18n';
export function TermsOfServicePage() {
  const {
    lang
  } = useTranslation();
  const en = lang === 'en';
  const ru = lang === 'ru';
  return <main className="min-h-screen bg-dark-bg pt-24 pb-16" data-id="element-1072">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1073">
        <h1 className="text-3xl md:text-4xl font-black text-white mb-8" data-id="element-1074">
          {en ? 'Terms of Service' : ru ? 'Условия использования' : 'Uslovi korišćenja'}
        </h1>
        <div className="prose prose-invert max-w-none text-gray-300 space-y-6" data-id="element-1075">
          <p data-id="element-1076">
            Dobrodošli na dtech.rs. Pristupom i korišćenjem ovog sajta,
            prihvatate sledeće uslove korišćenja. Molimo vas da ih pažljivo
            pročitate.
          </p>

          <h2 className="text-xl font-bold text-white mt-8" data-id="element-1077">
            1. Opšte odredbe
          </h2>
          <p data-id="element-1078">
            Sajt dtech.rs je u vlasništvu kompanije DTECH ATLAS DOO. Sadržaj na
            sajtu je informativnog karaktera i odnosi se na prodaju i promociju
            električnih transportera za stepenice i prateće opreme.
          </p>

          <h2 className="text-xl font-bold text-white mt-8" data-id="element-1079">
            2. Informacije o proizvodima
          </h2>
          <p data-id="element-1080">
            Trudimo se da podaci o proizvodima (specifikacije, cene, opisi) budu
            što precizniji. Međutim, zadržavamo pravo na greške i promene.
            Fotografije proizvoda su informativnog karaktera i mogu odstupati od
            stvarnog izgleda proizvoda usled tehničkih modifikacija dobavljača.
          </p>

          <h2 className="text-xl font-bold text-white mt-8" data-id="element-1081">
            3. Cene i dostupnost
          </h2>
          <p data-id="element-1082">
            Sve cene su izražene u evrima (EUR) i podložne su promenama bez
            prethodne najave. Dostupnost proizvoda zavisi od stanja na zalihama
            i rokova proizvodnje. Konačna potvrda cene i roka isporuke vrši se
            prilikom obrade vašeg upita ili porudžbine.
          </p>

          <h2 className="text-xl font-bold text-white mt-8" data-id="element-1083">
            4. Intelektualna svojina
          </h2>
          <p data-id="element-1084">
            Sav sadržaj na sajtu (tekstovi, fotografije, video materijali,
            logotipi) je zaštićen autorskim pravima i vlasništvo je DTECH ATLAS
            DOO ili naših partnera. Neovlašćeno korišćenje, kopiranje ili
            distribucija sadržaja je strogo zabranjeno.
          </p>

          <h2 className="text-xl font-bold text-white mt-8" data-id="element-1085">
            5. Ograničenje odgovornosti
          </h2>
          <p data-id="element-1086">
            DTECH ATLAS DOO ne snosi odgovornost za eventualnu štetu nastalu
            korišćenjem sajta ili nemogućnošću pristupa sajtu. Takođe, ne
            odgovaramo za sadržaj eksternih linkova koji mogu biti postavljeni
            na našem sajtu.
          </p>
        </div>
      </div>
    </main>;
}